export const API_ENDPOINT = {
  BTG_PREDICTIVE_PAGE: "/getBTGGrowthData",
};

export const DATA_TABLE = [
  {
    label: "Purchased Item ID",
    key: "purchase_item",
  },
  {
    label: "Purchased Item Description",
    key: "purchase_itemDesc",
  },
  {
    label: "Go Together Item ID",
    key: "gotogether_item",
  },
  {
    label: "Go Together Item Description",
    key: "gotogether_itemDesc",
  },
  {
    label: "Purchased L3",
    key: "l3",
  },
  {
    label: "Purchased L4",
    key: "l4",
  },
  {
    label: "Price ($/each)",
    key: "price",
  },
  {
    label: "Margin ($/each)",
    key: "margin",
  },
  {
    label: "Recommended Quantity",
    key: "quantity",
  },
  {
    label: "Cost ($/each)",
    key: "cost",
  },
  {
    label: "Opportunity Revenue($)",
    key: "OpportunityRevenue",
  },
  {
    label: "Opportunity Margin($)",
    key: "OpportunityMargin",
  },
];

export const DUMMY = [
  {
    name: "Start",
    uv: 2400,
    pv: 0,
  },
  {
    name: "",
    uv: -400,
    pv: 2400,
  },
  {
    name: "",
    uv: 400,
    pv: 2000,
  },
  { name: "Final", uv: 3700, pv: 0 },
  {
    name: "Start",
    uv: 2400,
    pv: 0,
  },
  {
    name: "",
    uv: -400,
    pv: 2400,
  },
  {
    name: "",
    uv: 400,
    pv: 2000,
  },
  { name: "Final", uv: 3700, pv: 0 },
  {
    name: "Start",
    uv: 2400,
    pv: 0,
  },
  {
    name: "",
    uv: -400,
    pv: 2400,
  },
  {
    name: "",
    uv: 400,
    pv: 2000,
  },
  { name: "Final", uv: 3700, pv: 0 },
  {
    name: "Start",
    uv: 2400,
    pv: 0,
  },
  {
    name: "",
    uv: -400,
    pv: 2400,
  },
  {
    name: "",
    uv: 400,
    pv: 2000,
  },
  { name: "Final", uv: 3700, pv: 0 },
];

export const CUST_SUB_MKT = [
  { key: "01", value: "Electrical Contractor" },
  { key: "02", value: "Residential Contract" },
  { key: "03", value: "Industrial Contractor" },
  { key: "04", value: "Comm Data Contractor" },
  { key: "05", value: "Comm Data Contractor" },
  { key: "06", value: "Lighting Management" },
  { key: "07", value: "ESCOs" },
  { key: "08", value: "Engineering, Procurement & Construction" },
  { key: "09", value: "General / Heavy Construction" },
  { key: "10", value: "Plumbing, Heating, Air Conditioning" },
  { key: "11", value: "Special Trade Contractor" },
  { key: "12", value: "Broadband OSP Contractor" },
  { key: "13", value: "Broadband Central Office" },
  { key: "14", value: "Broadband Splice Contractor" },
  { key: "15", value: "Broadband Wireless Contractor" },
  { key: "20", value: "Food & Beverage" },
  { key: "21", value: "Automotive/Transportation" },
  { key: "22", value: "Metals, Mining, Minerals" },
  { key: "23", value: "Fibers & Textiles" },
  { key: "24", value: "Chemical Processing" },
  { key: "25", value: "Oil & Gas" },
  { key: "26", value: "Printing & Publishing" },
  { key: "27", value: "Pulp & Paper" },
  { key: "28", value: "Power Generation" },
  { key: "29", value: "Tire & Rubber" },
  { key: "30", value: "Water / Wastewater" },
  { key: "31", value: "Other(Agri,Textiles, etc.)" },
  { key: "40", value: "Panel Shops" },
  { key: "41", value: "Oilfield Equipment" },
  { key: "42", value: "Conveyors & Material Handling" },
  { key: "44", value: "Packaging Machinery" },
  { key: "45", value: "Electrical / Electronic Equipment" },
  { key: "46", value: "Integrator" },
  { key: "47", value: "Turbine gen,gensets, Engines" },
  { key: "48", value: "Other" },
  { key: "50", value: "Electric Utility T&D" },
  { key: "51", value: "Broadband Utility Voice/Data" },
  { key: "53", value: "Farm Equip & Construction" },
  { key: "54", value: "HVAC Equipment" },
  { key: "55", value: "Indust&Commer Machinery" },
  { key: "56", value: "Instrumentation" },
  { key: "57", value: "Metal Working Machinery" },
  { key: "58", value: "Pumps & Pumping System" },
  { key: "59", value: "Relays & Industrial" },
  { key: "60", value: "Entertainment" },
  { key: "61", value: "Financial" },
  { key: "62", value: "Healthcare" },
  { key: "63", value: "Retail and Hospital" },
  { key: "64", value: "Property Owners / Management" },
  { key: "65", value: "Services" },
  { key: "66", value: "Transportation" },
  { key: "67", value: "Wholesale" },
  { key: "68", value: "Federal" },
  { key: "69", value: "State & Local" },
  { key: "70", value: "Education" },
  { key: "80", value: "Tier I Telecommunications Carrier" },
  { key: "81", value: "Tier II / Tier III /" },
  { key: "82", value: "Wireless Carrier" },
  { key: "83", value: "Wireless Tower Company" },
  { key: "84", value: "Rural Electrical Co-operative" },
  { key: "85", value: "Cable TV" },
  { key: "86", value: "Wireless Internet Service Provider" },
  { key: "87", value: "Engineer / Consultant" },
  { key: "NA", value: "Unknown" },
];

export const COMMODITY = [
  "ALAN WIRE",
  "ATKORE INTERNATIONAL",
  "BELDEN",
  "CANTEX, INCORPORATED",
  "CERRO WIRE & CABLE CO., INC.",
  "CME WIRE AND CABLE",
  "COLONIAL WIRE AND CABLE CO., INC.",
  "CONDUIT PIPE PRODUCTS",
  "ENCORE WIRE LIMITED",
  "KING WIRE",
  "OMNI CABLE & HOUSTON WIRE & CABLE COMPANY",
  "PICOMA",
  "PRIORITY WIRE & CABLE",
  "PRYSMIAN CABLES AND SYSTEMS USA LLC",
  "REPUBLIC CONDUIT",
  "REPUBLIC WIRE, INC.",
  "SERVICE WIRE",
  "SOUTHERN PIPE, INC.",
  "SOUTHWIRE",
  "WESTERN TUBE & CONDUIT CORPORATION",
  "WHEATLAND TUBE COMPANY",
];


function firstFridayOfFebruaryUTC(year:any) {
  const feb1 = new Date(Date.UTC(year, 1, 1));
  const FRI = 5; // 0=Sun ... 5=Fri
  const offsetDays = (FRI - feb1.getUTCDay() + 7) % 7;
  return new Date(Date.UTC(year, 1, 1 + offsetDays));
}

export function getDynamicFYYear(today = new Date()) {
  const y = today.getUTCFullYear();
  const anchorThisYear = firstFridayOfFebruaryUTC(y);
  const anchorYear = today >= anchorThisYear ? y : y - 1;
  return anchorYear - 1;
}


export function getTimelineOptions(today = new Date()) {
  const fyYear = getDynamicFYYear(today);
  return [
    { label: `FY${fyYear}`, value: "LastYear" },
    { label: "YTD", value: "YTD" },
    { label: "Running 12 Months", value: "running12Month" },
  ];
}

